export const getPageTrackingData = (pathname) => {
  const mappings = [
    {
      pattern: "/general-categories/1",
      data: {
        page_location: "/story-choice",
        page_title: "Story Choice",
      },
    },
    {
      pattern: "/general-categories-options/1/4",
      data: {
        page_location: "/book-biography/title",
        page_title: "Book Biography Title",
      },
    },
    {
      pattern: "/general-categories-options/1/2",
      data: {
        page_location: "/book-generic/title",
        page_title: "Book Generic Title",
      },
    },
    {
      pattern: "/general-categories-options/1/3",
      data: {
        page_location: "/book-self-development/title",
        page_title: "Book Self Development Title",
      },
    },
    {
      pattern: /^\/questions\/\d+$/,
      data: {
        page_location: "/book-creation",
        page_title: "Book Creation",
      },
    },
    {
      pattern: "/my-books",
      data: {
        page_location: "/personal-library",
        page_title: "Personal Library",
      },
    },
    {
      pattern: "/manage-subscriptions",
      data: {
        page_location: "/area-subscription",
        page_title: "Area Subscription",
      },
    },
    {
      pattern: "/subscriptions",
      data: {
        page_location: "/subscription/payment",
        page_title: "Subscription Payment",
      },
    },
    {
      pattern: "/thankyou/purchase",
      data: {
        page_location: "/thank-you-page",
        page_title: "Thank you page",
      },
    },
    {
      pattern: "/gift-card",
      data: {
        page_location: "/gift-card",
        page_title: "Gift Card Choice",
      },
    },
    {
      pattern: "/gift-card-payment",
      data: {
        page_location: "/gift-card-email",
        page_title: "Email Gift Card",
      },
    },
    {
      pattern: "/gift-card-form",
      data: {
        page_location: "/gift-card/payment",
        page_title: "Gift Card Payment",
      },
    },
    {
      pattern: "/printing",
      data: {
        page_location: "/print",
        page_title: "Book Print",
      },
    },
    {
      pattern: "/printing-payment",
      data: {
        page_location: "/print/payment",
        page_title: "Print Payment",
      },
    },
    {
      pattern: "/login",
      data: {
        page_location: "/login",
        page_title: "Login",
      },
    },
    {
      pattern: "/forgot-password",
      data: {
        page_location: "/forgot-password",
        page_title: "Forgot Password",
      },
    },
    {
      pattern: "/register",
      data: {
        page_location: "/sign-up",
        page_title: "Sign up",
      },
    },
    {
      pattern: "/payment",
      data: {
        page_location: "/single-book/payment",
        page_title: "Single Book Payment",
      },
    },
  ];

  for (const { pattern, data } of mappings) {
    if (typeof pattern === "string" && pathname === pattern) {
      return data;
    }
    if (pattern instanceof RegExp && pattern.test(pathname)) {
      return data;
    }
  }

  return null;
};
